import { useEffect, useRef, useState } from "react";
import { closeInvoicesJobView, getOwner, getUser, openInvoicesJobView, toPrettyDate, useEnvironment, useGlobal, useHub, useSocket } from "../../../../../core/Global"
import Job from "../../models/Job"
import Indicator from "../../../../../components/base/Indicator";
import { API_ROUTES } from "../../../../../core/Constants";
import JobInvoice, { JobInvoiceItem } from "../../models/JobInvoice";
import Icon from "../../../../../components/base/Icon";
import Modal from "../../../../../components/base/Modal";
import DropDown from "../../../../../components/form/DropDown";
import DataItem from "../../../../../models/DataItem";
import TextBox from "../../../../../components/form/TextBox";
import TextArea from "../../../../../components/form/TextArea";
import ToggleSwitch from "../../../../../components/form/ToggleSwitch";
import { CompactTax } from "../../../../system/taxes/models/TaxItem";
import { AmountType, InvoiceItemTypes } from "../../../../../core/Enums";
import FlexRow from "../../../../../components/base/FlexRow";
import { Link, useNavigate } from "react-router-dom";
import Avatar from "../../../../../components/base/Avatar";
import { toastError, toastSuccess } from "../../../../../components/base/Toast";
import PhoneInput from "../../../../../components/form/PhoneInput";
import Company from "../../../../accounts/models/Company";
import { DrawerForm } from "../../../../../components/drawers/DrawerForm";
import DatePicker from "../../../../../components/form/DatePicker";
import FormTitle from "../../../../../components/form/FormTitle";
import { Drawer } from "../../../../../components/drawers/Drawer";
import { BottomSheet } from "../../../../../components/base/BottomSheet";
import Form from "../../../../../components/form/Form";
import IconButton from "../../../../../components/base/IconButton";
import Div from "../../../../../components/base/Div";
import MobileJobInvoiceSignature from "./MobileJobInvoiceSignature";
import { useTapToPay } from "../../../../../hooks/useTapToPay";
import TapToPayIcon from "../../../../../components/taptopay/TapToPayIcon";
import { isNativeiOSApp } from "../../../../../NativeAppBrdige";



interface IProps {
    job: Job
    invoiceId: string
}

export default function JobInvoiceDetails(props: IProps) {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });



    const hub = useHub()
    const user = getUser()
    const socket = useSocket()
    const owner = getOwner()
    const nav = useNavigate()
    const env = useEnvironment()
    const [globalState] = useGlobal()

    // Tap to Pay on iPhone: within the checkout flow we either let the merchant
    // pay (when set up) or trigger enablement first (Apple requirement 3.7).
    // Only surfaces at all when the account has gateway keys from the server.
    const {
        eligible: tapToPayEligible,
        enabled: tapToPayEnabled,
        gatewayConfigured: tapToPayGatewayConfigured,
        startSetup: startTapToPaySetup,
    } = useTapToPay()

    // Apple's naming and glyph only apply to iOS; Android keeps the neutral label.
    const isIOSApp = isNativeiOSApp()

    // One checkout button, one label (Apple requirement 5.3): on iOS, when Tap to
    // Pay isn't enabled yet the same button invokes the setup / T&C flow instead
    // of the payment. Android has no separate enablement step.
    const payWithTapToPay = () => {
        if (isIOSApp && !tapToPayEnabled) {
            startTapToPaySetup()
            return
        }
        window.location.href =
            `rinvox://taptopay?owner=${owner?.id}&id=${model?.id}&token=${model?.token}`
    }

    const [signaturePadModal, setSignaturePadModal] = useState<boolean>(false);

    useEffect(() => {
        console.log("Signature Pad Modal: ", signaturePadModal);
    }, [signaturePadModal]);

    const [loading, loadingSet] = useState<boolean>(true);
    const [model, modelSet] = useState<JobInvoice>()
    const [invoiceOrEstimate, invoiceOrEstimateSet] = useState<string>("Estimate");
    const [invoiceOrEstimates, invoiceOrEstimatesSet] = useState<string>("Estimates");

    const [company, companySet] = useState<Company>();

    const fetchCompany = () => {
        hub.Get(API_ROUTES.ProfileCompany, res => {
            if (res.success && res.data) companySet(res.data);
        })
    }

    const [estimates, estimatesSet] = useState<JobInvoice[]>();
    const [invoices, invoicesSet] = useState<JobInvoice[]>();

    const [selectedItem, selectedItemSet] = useState<JobInvoiceItem>();

    useEffect(() => {
        if (selectedItem) {
            itemAmountSet(selectedItem.amount ?? 0);
            itemQtySet(selectedItem.qty ?? 0);
            selectedTaxSet(selectedItem.tax);
            taxIncludedSet(selectedItem.tax?.included ?? false);
        }
    }, [selectedItem])

    const [ItemTypes] = useState<DataItem[]>([
        {
            id: "1",
            name: "Product"
        },
        {
            id: "2",
            name: "Service"
        },
        {
            id: "3",
            name: "Hour"
        },
        {
            id: "4",
            name: "Expense"
        }
    ])

    const [itemFormModal, itemFormModalSet] = useState<boolean>(false);
    const [invSettingsModal, invSettingsModalSet] = useState<boolean>(false);
    const [confirmModal, confirmModalSet] = useState<boolean>(false);
    const [undoConfirmModal, undoConfirmModalSet] = useState<boolean>(false);
    const [deleteModal, deleteModalSet] = useState<boolean>(false);
    const [reset, resetSet] = useState<boolean>(false);

    useEffect(() => {
        if (reset) {
            selectedItemSet(undefined);
            selectedTaxSet(undefined);
            itemAmountSet(0);
            itemQtySet(0);
            itemTotalAmountSet(0);
            selectedTaxSet(undefined);
            taxIncludedSet(false);
            setTimeout(() => {
                resetSet(false);
            }, 1000);
        }
    }, [reset])

    const [deleteInvoiceItem, deleteInvoiceItemSet] = useState<boolean>(false);
    const [sendInvoiceModal, sendInvoiceModalSet] = useState<boolean>(false);
    const [sendAll, sendAllSet] = useState<boolean>(false);
    const [addTax, addTaxSet] = useState<boolean>(false);
    const [estToInvModal, estToInvModalSet] = useState<boolean>(false);
    const [estToInvErrModal, estToInvErrModalSet] = useState<boolean>(false);

    const [previewModal, previewModalSet] = useState<boolean>(false);

    const [taxes, taxesSet] = useState<CompactTax[]>([]);
    const fetchTaxes = () => {
        hub.Get(API_ROUTES.Taxes + "all", res => {
            if (res.success) {
                taxesSet([{ id: "", nameWithAmount: "No Tax" }, ...res.data])
            }
        })
    }

    const fetchInvoice = () => {
        hub.Get(API_ROUTES.JobInvoices + props.invoiceId, res => {
            if (res.success) {
                modelSet(res.data);
                loadingSet(false);
            }
        })
    }



    useEffect(() => {

        fetchInvoice();
        fetchTaxes();
        fetchCompany();

    }, [props.invoiceId])

    useEffect(() => {
        invoiceOrEstimateSet(model?.issued ? "Invoice" : "Estimate");
        invoiceOrEstimatesSet(model?.issued ? "Invoices" : "Estimates");
        if (model) {
            if (loading && model.items!.length == 0) {
                itemFormModalSet(true);
            }
            loadingSet(false);
        }
    }, [model]);


    const [itemAmount, itemAmountSet] = useState<number>(0);
    const [itemQty, itemQtySet] = useState<number>(0);
    const [itemTotalAmount, itemTotalAmountSet] = useState<number>(0);
    const [selectedTax, selectedTaxSet] = useState<CompactTax>();
    const [taxIncluded, taxIncludedSet] = useState<boolean>(false);

    useEffect(() => {
        if (itemAmount == 0 || itemQty == 0) itemTotalAmountSet(0);
        else {
            var am = itemAmount;
            var tx = 0;
            var qty = itemQty;
            if (selectedTax?.amount && !taxIncluded) {
                if (selectedTax.amountType == AmountType.Percent) tx = (am * selectedTax.amount) / 100;
                else tx = selectedTax.amount
            }

            var t = (am + tx) * qty;
            itemTotalAmountSet(t);

            console.log(itemAmount, itemQty);
        }
    }, [itemAmount, itemQty, selectedTax, taxIncluded])

    useEffect(() => {
        if (addTax && selectedTax?.amount) {
            var tx = 0;
            var t = model?.total ?? 0;
            if (selectedTax.amountType == AmountType.Percent) tx = (t * selectedTax.amount) / 100;
            else tx = selectedTax.amount;
            taxAmountForTaxModalSet(tx);
            if (!taxIncluded) t += tx;
            totalForTaxModalSet(t);
        }
        else {
            taxAmountForTaxModalSet(0);
            totalForTaxModalSet(model?.total ?? 0);
        }
    }, [selectedTax, taxIncluded, addTax])

    const ItemTotalAmount = () => (
        <div>
            <div className="fs-1 fw-bolder">
                {moneyFormatter.format(itemTotalAmount)}
            </div>
            <div className="fs-7 fw-bold">
                Total
            </div>
        </div>
    )


    const [totalForTaxModal, totalForTaxModalSet] = useState<number>(0);
    const [taxAmountForTaxModal, taxAmountForTaxModalSet] = useState<number>(0);
    const TaxAmountFooter = () => (
        <div>
            <div className="fs-1 fw-bolder">
                {moneyFormatter.format(totalForTaxModal)}
            </div>
            <div className="fs-7 fw-bold">
                Tax Amount: {moneyFormatter.format(taxAmountForTaxModal)}
            </div>
        </div>
    )

    const [editInvoice, editInvoiceSet] = useState<boolean>(false);
    const [updateIssuedModal, updateIssuedModalSet] = useState<boolean>(false);
    const [openSwipeRow, openSwipeRowSet] = useState<number | null>(null);
    const [acceptingInvoice, acceptingInvoiceSet] = useState<boolean>(false);
    const [signatureMode, signatureModeSet] = useState<"sign" | "convert">("sign");
    const [convertConfirmModal, convertConfirmModalSet] = useState<boolean>(false);

    useEffect(() => {
        if (openSwipeRow !== null) {
            const handler = (e: Event) => {
                const target = e.target as HTMLElement | null
                if (!target || !target.closest('[data-swipe-open="true"]')) {
                    openSwipeRowSet(null)
                }
            }
            // delay by one tick so the same click/touch that opened the row doesn't immediately close it
            const t = setTimeout(() => {
                document.addEventListener("mousedown", handler)
                document.addEventListener("touchstart", handler, { passive: true })
            }, 0)
            return () => {
                clearTimeout(t)
                document.removeEventListener("mousedown", handler)
                document.removeEventListener("touchstart", handler)
            }
        }
    }, [openSwipeRow])

    const [sendTo, sendToSet] = useState<"email" | "phone" | "wa">("email")

    const ToolbarComponent = () => (
        <FlexRow>
            <IconButton icon="plus" type="regular" size={22}
                onClick={e => {
                    selectedItemSet(undefined)
                    itemFormModalSet(true)
                    itemAmountSet(0)
                    itemQtySet(0)
                    itemTotalAmountSet(0)
                    selectedTaxSet(undefined)
                    taxIncludedSet(false)
                }} />
            <IconButton icon="cog" type="regular" size={22}
                onClick={e => {
                    invSettingsModalSet(true)
                }} />
            <IconButton icon="share" type="regular" size={22}
                onClick={e => {
                    sendInvoiceModalSet(true)
                }} />
        </FlexRow>
    )

    useEffect(() => {

        var socketKey = socket.start(
            skt => {
                skt.invoke("StartListenToJobInvoice", props.invoiceId)
                    .then(() => {
                        skt.on(`UpdateJobInvoice-${props.invoiceId}`, inv => {
                            modelSet(prev => prev ? { ...prev, ...inv } : inv)
                        })
                    })
            }, skt => {
                skt.off("UpdateJobInvoice-" + props.invoiceId)
                skt.invoke("StopListenToJobInvoice", props.invoiceId)
            })

        return () => {
            socket.stop(socketKey);
        }

    }, [])

    const needAccept = !!model?.acceptRequired && !model?.acceptLog;
    const needSign = !!model?.signatureRequired && !model?.signatureLog;
    const canPay = !!model?.paymentEnabled && !needAccept && !needSign;

    const acceptInvoiceByTech = () => {
        if (model?.token && owner?.id) {
            acceptingInvoiceSet(true);
            hub.Post("/base/public/job/invoice/accept", {
                token: model.token,
                id: model.id,
                ownerUserId: owner.id
            }, (res: any) => {
                acceptingInvoiceSet(false);
                if (res.success && res.data) {
                    modelSet(res.data);
                } else {
                    toastError(res.message || "Failed to accept the invoice.");
                }
            })
        } else {
            toastError("Missing invoice token.");
        }
    };

    return (
        <>

            <Drawer id="drawer-job-invoice-view"
                title={`${invoiceOrEstimate} ${model?.number}`}
                toolbarComponent={ToolbarComponent}
                onClose={() => {
                    closeInvoicesJobView()
                    globalState.invoiceJobViewOnClose?.()
                }}>

                {
                    loading ?
                        <div className="my-20">
                            <Indicator text="Please wait..." />
                        </div>
                        :
                        <>

                            {
                                (model?.acceptLog || model?.signatureLog || model?.paid) ?
                                    <div style={{
                                        display: "flex",
                                        gap: 6,
                                        flexWrap: "wrap",
                                        marginBottom: 14
                                    }}>
                                        {
                                            model?.acceptLog &&
                                            <span style={statusPill("var(--bs-success-bg-subtle)", "var(--bs-success)")}>
                                                <Icon icon="check-circle" size={10} className="me-1" type="solid" />
                                                Accepted
                                            </span>
                                        }
                                        {
                                            model?.signatureLog &&
                                            <span style={statusPill("var(--bs-primary-bg-subtle)", "var(--bs-primary)")}>
                                                <Icon icon="signature" size={10} className="me-1" type="solid" />
                                                Signed
                                            </span>
                                        }
                                        {
                                            model?.paid &&
                                            <span style={statusPill("var(--bs-success-bg-subtle)", "var(--bs-success)")}>
                                                <Icon icon="circle-dollar" size={10} className="me-1" type="solid" />
                                                Paid
                                            </span>
                                        }
                                    </div>
                                    : null
                            }

                            <div>
                                {
                                    (!model?.items || model.items.length === 0) ?
                                        <div style={{
                                            textAlign: "center",
                                            padding: "40px 16px",
                                            color: "var(--bs-tertiary-color)",
                                            fontSize: 13
                                        }}>
                                            No items yet — tap <Icon icon="plus" size={11} /> to add one
                                        </div>
                                        :
                                        <div style={{ marginBottom: 20, marginLeft: "-1.5rem", marginRight: "-1.5rem" }}>
                                            {
                                                model?.items?.map((item, key) => {
                                                    const typeName = ItemTypes.filter(f => f.id == item.itemType?.toString())[0]?.name
                                                    const isHourly = item.itemType == InvoiceItemTypes.HourlyService
                                                    return (
                                                        <SwipeRow key={key}
                                                            rowKey={key}
                                                            openRowKey={openSwipeRow}
                                                            onOpenChange={openSwipeRowSet}
                                                            onEdit={() => {
                                                                selectedItemSet(item)
                                                                itemFormModalSet(true)
                                                            }}
                                                            onDelete={() => {
                                                                selectedItemSet(item)
                                                                deleteInvoiceItemSet(true)
                                                            }}>
                                                            <div style={{
                                                                display: "flex",
                                                                gap: 12,
                                                                padding: "14px 16px",
                                                            }}>
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                <div style={{
                                                                    fontSize: 15,
                                                                    fontWeight: 600,
                                                                    color: "var(--bs-body-color)",
                                                                    marginBottom: 4,
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis"
                                                                }}>
                                                                    {item.title}
                                                                </div>
                                                                <FlexRow style={{ gap: 6, flexWrap: "wrap" }}>
                                                                    {typeName &&
                                                                        <span style={{
                                                                            fontSize: 10,
                                                                            fontWeight: 600,
                                                                            letterSpacing: 0.3,
                                                                            textTransform: "uppercase",
                                                                            color: "var(--bs-secondary-color)",
                                                                            background: "var(--bs-secondary-bg)",
                                                                            padding: "2px 8px",
                                                                            borderRadius: 999
                                                                        }}>
                                                                            {typeName}
                                                                        </span>
                                                                    }
                                                                    <span style={{ fontSize: 12, color: "var(--bs-secondary-color)" }}>
                                                                        {item.qty}{isHourly ? "h" : ""} × {moneyFormatter.format(item.amount ?? 0)}
                                                                    </span>
                                                                </FlexRow>
                                                                {
                                                                    !window.isNullOrEmpty(item.description) &&
                                                                    <div style={{
                                                                        fontSize: 12,
                                                                        color: "var(--bs-tertiary-color)",
                                                                        marginTop: 4,
                                                                        lineHeight: 1.4
                                                                    }}>
                                                                        {item.description}
                                                                    </div>
                                                                }
                                                                {
                                                                    item.tax &&
                                                                    <div style={{ fontSize: 11, color: "var(--bs-tertiary-color)", marginTop: 4 }}>
                                                                        {item.tax.included ? "" : "+"} {item.tax.name} {item.tax.amountText}
                                                                        {item.tax.included && <Icon icon="circle-info" className="ms-1" size={10} type="solid" title="Included Tax" />}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div style={{
                                                                textAlign: "right",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "flex-end",
                                                                justifyContent: "center",
                                                                minWidth: 80
                                                            }}>
                                                                <div style={{ fontSize: 16, fontWeight: 700, color: "var(--bs-body-color)" }}>
                                                                    {moneyFormatter.format(item.totalAmount ?? 0)}
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </SwipeRow>
                                                    )
                                                })
                                            }
                                        </div>
                                }

                                <div style={{
                                    background: "var(--bs-tertiary-bg)",
                                    padding: "14px 16px",
                                    marginLeft: "-1.5rem",
                                    marginRight: "-1.5rem"
                                }}>
                                    <div style={totalRow}>
                                        <span style={totalLabel}>Subtotal</span>
                                        <span style={totalValue}>{moneyFormatter.format(model?.subtotal ?? 0)}</span>
                                    </div>

                                    {
                                        model?.itemsTotalTax && model.itemsTotalTax > 0 ?
                                            <div style={totalRow}>
                                                <span style={totalLabel}>Items Tax</span>
                                                <span style={totalValue}>{moneyFormatter.format(model.itemsTotalTax)}</span>
                                            </div>
                                            : <></>
                                    }

                                    {
                                        model?.taxes && model.taxes.length > 0 &&
                                        model.taxes.map((tax, key) =>
                                            <div key={key} style={totalRow}>
                                                <span style={{ ...totalLabel, display: "flex", alignItems: "center", gap: 6 }}>
                                                    <a href="#" title="Remove Tax" style={{ color: "var(--bs-tertiary-color)", display: "inline-flex" }}
                                                        onClick={e => {
                                                            e.preventDefault()
                                                            hub.Post(API_ROUTES.JobInvoices + "taxremove", {
                                                                id: model.id,
                                                                taxId: tax.id
                                                            }, res => {
                                                                if (res.success) modelSet(res.data)
                                                            })
                                                        }}>
                                                        <Icon icon="circle-xmark" size={13} />
                                                    </a>
                                                    {tax.amountType == AmountType.Percent ? tax.nameWithAmount : tax.name}
                                                </span>
                                                <span style={totalValue}>{moneyFormatter.format(tax.amount ?? 0)}</span>
                                            </div>
                                        )
                                    }

                                    <div style={{ ...totalRow, marginTop: 2 }}>
                                        <a href="#"
                                            style={{ fontSize: 12, fontWeight: 600, color: "var(--bs-primary)", display: "inline-flex", alignItems: "center", gap: 4 }}
                                            onClick={e => {
                                                e.preventDefault()
                                                addTaxSet(true)
                                                totalForTaxModalSet(model?.total ?? 0)
                                                taxAmountForTaxModalSet(0)
                                            }}>
                                            <Icon icon="plus" size={10} />
                                            Add Tax
                                        </a>
                                    </div>

                                    <div style={{
                                        borderTop: "1px solid var(--bs-border-color)",
                                        marginTop: 10,
                                        paddingTop: 12,
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}>
                                        <span style={{ fontSize: 15, fontWeight: 600, color: "var(--bs-body-color)" }}>Total</span>
                                        <span style={{ fontSize: 20, fontWeight: 700, color: "var(--bs-body-color)" }}>
                                            {moneyFormatter.format(model?.total ?? 0)}
                                        </span>
                                    </div>

                                    {
                                        model?.signatureLog?.fileUrl &&
                                        <div style={{ marginTop: 16 }}>
                                            <img src={`${env.hubUrl}${model.signatureLog.fileUrl}`}
                                                alt="Customer signature"
                                                style={{ maxWidth: "100%", maxHeight: 120 }} />
                                            <div style={{ fontSize: 11, color: "var(--bs-secondary-color)", marginTop: 4 }}>
                                                Signed on {toPrettyDate(model.signatureLog.createdAt)}
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className="mt-10">

                                    {
                                        !model?.issued &&
                                        <button type="button"
                                            className="btn btn-primary w-100 mb-3"
                                            onClick={() => {
                                                if (model?.signatureRequired) {
                                                    signatureModeSet("convert");
                                                    setSignaturePadModal(true);
                                                } else {
                                                    convertConfirmModalSet(true);
                                                }
                                            }}>
                                            <Icon icon="file-invoice-dollar" className="me-2" />
                                            Convert to Invoice
                                        </button>
                                    }

                                    {
                                        model?.issued && needAccept && !needSign &&
                                        <button type="button"
                                            className="btn btn-success w-100 mb-3"
                                            disabled={acceptingInvoice}
                                            onClick={acceptInvoiceByTech}>
                                            {
                                                acceptingInvoice
                                                    ? <Indicator text="Accepting..." />
                                                    : <><Icon icon="check" className="me-2" />Accept Invoice</>
                                            }
                                        </button>
                                    }

                                    {
                                        model?.issued && needSign &&
                                        <button type="button"
                                            className="btn btn-success w-100 mb-3"
                                            onClick={() => {
                                                signatureModeSet("sign");
                                                setSignaturePadModal(true);
                                            }}>
                                            <Icon icon="signature" className="me-2" />
                                            {needAccept ? "Sign & Accept" : "Sign Invoice"}
                                        </button>
                                    }


                                    {/* <a href={`${env.hubUrl}/base/public/job/invoice/download/${owner?.id}/${props.invoiceId}/${model?.token}`}
                                        className="btn btn-primary w-100 mb-3" target="_blank">
                                        <Icon icon="file-pdf" className="me-2" />
                                        Download PDF
                                    </a> */}

                                </div>

                                {
                                    // Tap to Pay on iPhone — only for eligible phones whose account has
                                    // gateway keys. Sticks to the bottom of the drawer so it's reachable
                                    // without scrolling, and sits above any other payment option
                                    // (Apple requirements 5.1 & 5.2). The label and icon never change
                                    // based on enablement (5.3): if Tap to Pay isn't set up yet, the same
                                    // button invokes the setup / T&C flow instead of the payment.
                                    model?.issued && canPay && tapToPayEligible && tapToPayGatewayConfigured &&
                                    <div style={{
                                        position: "sticky",
                                        bottom: 0,
                                        zIndex: 5,
                                        marginTop: 16,
                                        paddingTop: 12,
                                        paddingBottom: 12,
                                        backgroundColor: "var(--bs-body-bg)",
                                    }}>
                                        <button type="button"
                                            className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                                            onClick={payWithTapToPay}>
                                            <TapToPayIcon size={20} />
                                            {isIOSApp ? "Tap to Pay on iPhone" : "Tap to Pay"}
                                        </button>
                                    </div>
                                }
                            </div>

                            <Div visible={false} className="d-flex flex-column flex-xl-row">


                                <div className="m-0">
                                    <div className="d-print-none border border-dashed border-gray-300 card-rounded h-lg-100 w-350px p-5 bg-lighten">


                                        {
                                            model?.issued ?
                                                <FlexRow className="mb-2">

                                                </FlexRow>
                                                :
                                                <FlexRow className="mb-2">
                                                    {
                                                        model?.confirmed ?
                                                            <>
                                                                <a href="#" className="me-2"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        undoConfirmModalSet(true);
                                                                    }}>
                                                                    <Icon icon="undo" />
                                                                </a>
                                                                <span className="badge badge-success me-1">
                                                                    <Icon icon="check" className="me-2" />
                                                                    Approved
                                                                </span>
                                                                <a href="#" className="badge badge-light-success text-success"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        if (true) estToInvModalSet(true);
                                                                        else estToInvErrModalSet(true);
                                                                    }}>
                                                                    <Icon icon="file-invoice-dollar" className="me-2" />
                                                                    Create Invoice
                                                                </a>
                                                            </>
                                                            :
                                                            <>
                                                                <a href="#" className="badge badge-light-success text-success"
                                                                    onClick={e => {
                                                                        e.preventDefault();
                                                                        confirmModalSet(true);
                                                                    }}>
                                                                    <Icon icon="check" className="me-2" />
                                                                    Approve Estimate
                                                                </a>
                                                            </>
                                                    }
                                                </FlexRow>
                                        }

                                        {
                                            model?.sourceEstimateId && model.issued &&
                                            <div className="mb-2">
                                                <a href={`/crm/jobs/invoices/${model.jobId}/view/${model.sourceEstimateId}`}
                                                    target="_blank" title={"Created from Estimate: " + model.sourceEstimateNumber}>
                                                    <span className="badge badge-light-primary me-2">
                                                        Created from Estimate {model.sourceEstimateNumber}
                                                    </span>
                                                </a>
                                            </div>
                                        }

                                        {
                                            model?.lastSend &&
                                            <div className="mb-2">
                                                <span className="badge badge-light-primary me-2">
                                                    <Icon icon="share" className="me-2" />
                                                    Sent: {model.lastSend.sendDate}
                                                </span>
                                            </div>
                                        }
                                        {
                                            model?.viewsLog && model.viewsLog.length > 0 &&
                                            <div className="mb-2">
                                                <span className="badge badge-light-primary me-2">
                                                    <Icon icon="eye" className="me-2" />
                                                    Viewed: {toPrettyDate(model.viewsLog[model.viewsLog.length - 1].createdAt)}
                                                </span>
                                            </div>
                                        }
                                        {
                                            model?.acceptLog &&
                                            <div className="mb-2">
                                                <span className="badge badge-light-success me-2">
                                                    <Icon icon="check-circle" className="me-2" />
                                                    Accepted: {toPrettyDate(model.acceptLog.createdAt)}
                                                </span>
                                            </div>
                                        }
                                        {
                                            model?.confirmed &&
                                            <div className="mb-2">
                                                <span className="badge badge-light-success me-2">
                                                    <Icon icon="check" className="me-2" />
                                                    Confirmed: {model.confirmDate}
                                                </span>
                                            </div>
                                        }
                                        {
                                            model?.paid &&
                                            <div className="mb-2">
                                                <span className="badge badge-light-success me-2">
                                                    <Icon icon="circle-dollar" className="me-2" />
                                                    Paid: {toPrettyDate(model.paidAt)}
                                                </span>
                                            </div>
                                        }

                                        <div className="mb-4 mt-8 fw-boldest text-gray-600">TECHNICIAN</div>
                                        <FlexRow className="mb-10">
                                            <div className="me-2 h-40px">
                                                <Avatar avatarUrl={model?.tech?.avatarUrl} fullName={model?.tech?.fullName} width={40} />
                                            </div>
                                            <div>
                                                <div className="fw-bolder mb-1">{model?.tech?.fullName}</div>
                                                <FlexRow>
                                                    <Icon icon="phone-rotary" className="me-1 text-muted h-20px" size={12} type="solid" />
                                                    <span className="fs-8 text-muted h-20px">{model?.tech?.phoneNumber}</span>
                                                </FlexRow>
                                            </div>
                                        </FlexRow>

                                        <FlexRow className="mb-3 ">
                                            <span className="fw-boldest text-gray-600">{invoiceOrEstimate.toUpperCase()} DETAILS</span>
                                            <a href="#" className="ms-2"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    editInvoiceSet(true);
                                                }}>
                                                <Icon icon="edit" />
                                            </a>
                                        </FlexRow>

                                        <div className="mb-4">
                                            <div className="fw-bold text-gray-600 fs-7">Date:</div>
                                            <div className="fw-bolder text-gray-800 fs-6">{model?.issueDate}</div>
                                        </div>


                                        <FlexRow className="mb-3 mt-10">
                                            <span className="fw-boldest text-gray-600">BILLED TO</span>
                                        </FlexRow>

                                        <div className="mb-4">
                                            <div className="fw-bold text-gray-600 fs-7">Name:</div>
                                            <div className="fw-bolder text-gray-800 fs-6">{model?.billingName}</div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="fw-bold text-gray-600 fs-7">Phone:</div>
                                            <div className="fw-bolder text-gray-800 fs-6">{model?.billingPhone?.phoneFriendly}</div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="fw-bold text-gray-600 fs-7">Email:</div>
                                            <div className="fw-bolder text-gray-800 fs-6">
                                                {
                                                    window.isNullOrEmpty(model?.billingEmail) ?
                                                        <a href="#" className="fs-7"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                editInvoiceSet(true);
                                                            }}>
                                                            [Set Email Address]
                                                        </a>
                                                        :
                                                        <>{model?.billingEmail}</>
                                                }
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="fw-bold text-gray-600 fs-7">Address:</div>
                                            <div className="fw-bolder text-gray-800 fs-6">{model?.billingAddress}</div>
                                        </div>


                                        <FlexRow className="mb-3 mt-10">
                                            <span className="fw-boldest text-gray-600">PAY TO</span>
                                        </FlexRow>

                                        <div className="mb-4">
                                            <div className="fw-bolder text-gray-800 fs-6 mb-1">{model?.issuedByName}</div>
                                            <div className="text-gray-800 fs-7 line-break">{model?.issuedByAddress}</div>
                                            <div className="text-gray-800 fs-7">{model?.issuedByPhone}</div>
                                        </div>

                                        {
                                            model?.note && model.note.length > 0 &&
                                            <>
                                                <FlexRow className="mb-3 mt-10">
                                                    <span className="fw-boldest text-gray-600">NOTE</span>
                                                </FlexRow>
                                                <div className="mb-4 line-break">
                                                    {model.note}
                                                </div>
                                            </>
                                        }

                                        <FlexRow justify="end" className="mt-10">
                                            <button type="button" className="btn btn-sm btn-light-primary btn-active-light-primary me-1"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    previewModalSet(true)
                                                }}>
                                                <Icon icon="eye" /> Preview
                                            </button>
                                            <button type="button" className="btn btn-sm btn-success me-1"
                                                onClick={e => {
                                                    e.preventDefault();
                                                    sendInvoiceModalSet(true);
                                                    sendAllSet(false);
                                                }}>
                                                <Icon icon="share" /> Send
                                            </button>
                                            <div>
                                                <button className="btn btn-sm btn-light btn-icon"
                                                    data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                                    onClick={e => window.dataTableMenu()}>
                                                    <Icon icon="ellipsis-vertical" />
                                                </button>
                                                <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4" data-kt-menu="true">
                                                    <div className="menu-item">
                                                        <a href={`${env.hubUrl}/base/public/job/invoice/download/${owner?.id}/${props.invoiceId}/${model?.token}`} target="_blank" className="menu-link px-3">
                                                            <Icon icon="download" className="me-2" />
                                                            Download PDF
                                                        </a>
                                                    </div>
                                                    <div className="menu-item">
                                                        <a href="#" className="menu-link px-3 text-danger"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                deleteModalSet(true);
                                                            }}>
                                                            <Icon icon="trash-xmark" className="me-2" />
                                                            Delete {invoiceOrEstimate}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </FlexRow>

                                    </div>
                                </div>

                            </Div>
                        </>
                }

            </Drawer>

            {
                signaturePadModal &&
                <MobileJobInvoiceSignature invoiceId={props.invoiceId}
                    token={model?.token}
                    mode={signatureMode}
                    disclaimer={model?.disclaimer}
                    onClose={() => setSignaturePadModal(false)}
                    onSigned={(inv) => {
                        if (signatureMode === "convert") {
                            openInvoicesJobView(inv, globalState.invoiceJobViewOnClose ?? (() => { }));
                        } else {
                            modelSet(inv);
                        }
                    }} />
            }

            {
                invSettingsModal &&
                <BottomSheet id="bsheet-invoice-settings" open
                    minHeight={500}
                    onClose={() => {
                        invSettingsModalSet(false)
                    }}
                >
                    <Form autoIndiactor
                        onSubmit={(body, callback) => {

                            var valid = true;
                            var focus = true;

                            if (window.isNullOrEmpty(body.date)) {
                                window.formError("date", "Please select a valid date!", "bsheet-invoice-settings", focus);
                                focus = false;
                                valid = false;
                            }

                            if (window.isNullOrEmpty(body.billingname)) {
                                window.formError("billingname", "Please write the billing name!", "bsheet-invoice-settings", focus);
                                focus = false;
                                valid = false;
                            }

                            if (window.isNullOrEmpty(body.billingphone) || body.billingphone.length < 10) {
                                window.formError("billingphone", "Please write the billing phone!", "bsheet-invoice-settings", focus);
                                focus = false;
                                valid = false;
                            }

                            if (window.isNullOrEmpty(body.billingaddress)) {
                                window.formError("billingaddress", "Please write the billing address!", "bsheet-invoice-settings", focus);
                                focus = false;
                                valid = false;
                            }

                            // if (window.isNullOrEmpty(body.issuename)) {
                            //     window.formError("issuename", "Please write the name!", "modal-update-issuedinfo", focus);
                            //     focus = false;
                            //     valid = false;
                            // }

                            // if (window.isNullOrEmpty(body.issuephone) || body.issuephone.length < 9) {
                            //     window.formError("issuephone", "Please write the phone!", "modal-update-issuedinfo", focus);
                            //     focus = false;
                            //     valid = false;
                            // }


                            // if (window.isNullOrEmpty(body.issueaddress)) {
                            //     window.formError("issueaddress", "Please write the address!", "modal-update-issuedinfo", focus);
                            //     focus = false;
                            //     valid = false;
                            // }

                            if (!valid) {
                                callback!();
                                return;
                            }

                            hub.Post(API_ROUTES.JobInvoices + "editdetailsbytech", {
                                ...body,
                                id: props.invoiceId
                            }, res => {
                                if (res.success) {
                                    modelSet(res.data)
                                    invSettingsModalSet(false)
                                }
                                callback!(res);
                            })

                        }}>

                        <div className="mt-10 mb-10">
                            <FormTitle title="Billed To" margin={0} className="mb-5" />
                            <TextBox id="txt-billing-name" name="billingname" block labelUp value={model?.billingName} placeholder="Billing Name" />
                            <PhoneInput name="billingphone" block labelUp countryCodes="strict"
                                defaultValue={model?.billingPhone?.phone} parent="bsheet-invoice-settings" />
                            <TextBox id="txt-inv-email-address" name="billingemail" block labelUp placeholder="Email Address" email value={model?.billingEmail} />
                            <TextArea name="billingaddress" block labelUp placeholder="Billing Address" value={model?.billingAddress} rows={3} marginBottom={5} />

                            <DatePicker id="dt-invoice-date" name="date" block
                                parentId="bsheet-invoice-settings"
                                label={`${invoiceOrEstimate} Date`} labelUp date={model?.issuedAt} />

                            <FormTitle title="Note" margin={0} className="mb-5" />
                            <TextArea name="note" block labelUp placeholder="Write a note..." value={model?.note} rows={3} />

                            <button type="submit" className="btn btn-primary w-100 mb-3">
                                Update {invoiceOrEstimate}
                            </button>

                            <button type="button" className="btn btn-secondary w-100"
                                onClick={e => invSettingsModalSet(false)}>
                                Discard
                            </button>

                        </div>

                    </Form>
                </BottomSheet>
            }

            {
                itemFormModal &&
                <BottomSheet id="modal-add-invoice-item" open
                    onClose={() => {
                        itemFormModalSet(false)
                        selectedItemSet(undefined)
                        selectedTaxSet(undefined)
                        taxIncludedSet(false)

                        if (!model?.created) {
                            hub.Delete(API_ROUTES.JobInvoices + model?.id, res => { })
                            closeInvoicesJobView()
                        }
                    }}
                >

                    <Form autoIndiactor
                        onSubmit={(body, callback) => {

                            var valid = true;
                            var focus = true;

                            if (window.isNullOrEmpty(body.itemType)) {
                                window.formError("itemType", "Please select the item type!", "modal-add-invoice-item");
                                valid = false;
                            }

                            if (window.isNullOrEmpty(body.itemTitle)) {
                                window.formError("itemTitle", "Please write the item title!", "modal-add-invoice-item", focus);
                                valid = false;
                                focus = false;
                            }

                            if (window.isNullOrEmpty(body.amount)) {
                                window.formError("amount", "Please write the amount!", "modal-add-invoice-item", focus);
                                valid = false;
                                focus = false;
                            }

                            var qty = Number.parseInt(body.qty);
                            if (window.isNullOrEmpty(body.qty)) {
                                window.formError("qty", "Please write the quantity!", "modal-add-invoice-item", focus);
                                valid = false;
                                focus = false;
                            }
                            else if (isNaN(qty) || qty < 1) {
                                window.formError("qty", "The quantity must be greater than 0!", "modal-add-invoice-item", focus);
                                valid = false;
                                focus = false;
                            }

                            if (!valid) {
                                if (callback) callback();
                                return;
                            }

                            hub.Post(API_ROUTES.JobInvoices + "item", {
                                ...body,
                                id: props.invoiceId
                            }, res => {
                                if (res.success) {
                                    fetchInvoice()
                                    selectedItemSet(undefined)
                                    itemFormModalSet(false)
                                }
                                else {
                                    callback!();
                                }

                            })

                        }}>

                        {
                            selectedItem && <input type="hidden" name="row" value={selectedItem.row} />
                        }

                        <DropDown id="drp-invoice-item-type" name="itemType" source={ItemTypes} parentModal="modal-add-invoice-item" classicSelect
                            label="Item Type" labelUp block marginBottom={3} defaultValue={selectedItem?.itemType?.toString()} />

                        <TextBox id="txt-item-title" name="itemTitle" label="Item Title" labelUp block marginBottom={3} value={selectedItem?.title} clear={reset} />

                        <TextBox name="amount" label="Amount" labelUp block money icon="dollar-sign"
                            marginBottom={3} value={selectedItem?.amount?.toString()} clear={reset}
                            onChange={e => {
                                var a = Number.parseFloat(e.target.value.replaceAll(",", ""));
                                if (isNaN(a)) a = 0;
                                itemAmountSet(a);
                            }} />

                        <TextBox name="qty" label="Qty" labelUp block numeric marginBottom={3}
                            value={selectedItem?.qty?.toString()} clear={reset} maxLength={5}
                            onChange={e => {
                                var q = Number.parseInt(e.target.value);
                                if (isNaN(q)) q = 0;
                                itemQtySet(q);
                            }} />

                        <TextArea name="description" label="Description" labelUp block rows={3} marginBottom={3} value={selectedItem?.description} clear={reset} />

                        <DropDown id="drp-item-tax" name="taxId" parentModal="modal-add-invoice-item" defaultValue={selectedItem?.tax?.id}
                            source={taxes} dataText="nameWithAmount" dataValue="id" block label="Tax" labelUp reset={reset} classicSelect
                            onSelectItem={e => selectedTaxSet(e)} onClear={() => selectedTaxSet(undefined)} />

                        {
                            selectedTax && <ToggleSwitch name="taxIncluded" raw label="Tax is Included" small checked={selectedItem?.tax?.included}
                                onChange={e => taxIncludedSet(e)} />
                        }



                        <FlexRow className="mt-10">
                            <ItemTotalAmount />
                            <button className="btn btn-primary ms-auto" type="submit">
                                <Icon icon="plus" />
                                Add Item
                            </button>
                        </FlexRow>

                    </Form>

                </BottomSheet>
            }

            {
                deleteInvoiceItem &&
                <Modal id="modal-delete-invoice-item"
                    title="Delete Item"
                    buttonText="Delete Item"
                    buttonColor="danger"
                    open visible
                    onClose={() => {
                        deleteInvoiceItemSet(false);
                        selectedItemSet(undefined);
                    }}
                    onConfirm={callback => {

                        hub.Post(API_ROUTES.JobInvoices + "deleteitem", {
                            id: props.invoiceId,
                            row: selectedItem?.row
                        }, res => {
                            if (res.success) fetchInvoice();
                            callback();
                            selectedItemSet(undefined);
                        })
                    }}>

                    <div>
                        <p>
                            Do you want to delete this item?
                        </p>
                        <FlexRow className="p-5 bg-light-danger">
                            <div>
                                {selectedItem?.title}
                            </div>
                            <div className="ms-2">
                                ({moneyFormatter.format(selectedItem?.totalAmount ?? 0)})
                            </div>
                        </FlexRow>
                    </div>

                </Modal>
            }

            {
                addTax &&
                <BottomSheet id="bsheet-addtax-invoice" open
                    minHeight={360}
                    onClose={() => {
                        addTaxSet(false);
                        selectedTaxSet(undefined);
                        taxIncludedSet(false);
                    }}>

                    <Form autoIndiactor
                        onSubmit={(body, callback) => {
                            hub.Post(API_ROUTES.JobInvoices + "tax", {
                                ...body,
                                id: model?.id
                            }, res => {
                                callback!(res);
                                if (res.success) {
                                    modelSet(res.data);
                                    addTaxSet(false);
                                    selectedTaxSet(undefined);
                                    taxIncludedSet(false);
                                }
                            })
                        }}>

                        <FormTitle title="Add Tax" margin={0} className="mb-5" />

                        <DropDown id="drp-invoice-tax" name="taxId" parentModal="bsheet-addtax-invoice"
                            source={taxes} dataText="nameWithAmount" dataValue="id" block label="Tax" labelUp classicSelect
                            onSelectItem={e => selectedTaxSet(e)} onClear={() => selectedTaxSet(undefined)} />

                        {
                            selectedTax && <ToggleSwitch name="taxIncluded" raw label="Tax is Included" small checked={taxIncluded}
                                onChange={e => taxIncludedSet(e)} />
                        }

                        <div style={{
                            background: "var(--bs-tertiary-bg)",
                            borderRadius: 12,
                            padding: "14px 16px",
                            marginTop: 20,
                            marginBottom: 16
                        }}>
                            <div style={totalRow}>
                                <span style={totalLabel}>Tax Amount</span>
                                <span style={totalValue}>{moneyFormatter.format(taxAmountForTaxModal)}</span>
                            </div>
                            <div style={{
                                borderTop: "1px solid var(--bs-border-color)",
                                marginTop: 10,
                                paddingTop: 12,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}>
                                <span style={{ fontSize: 15, fontWeight: 600, color: "var(--bs-body-color)" }}>Total</span>
                                <span style={{ fontSize: 20, fontWeight: 700, color: "var(--bs-body-color)" }}>
                                    {moneyFormatter.format(totalForTaxModal)}
                                </span>
                            </div>
                        </div>

                        <button type="submit" className="btn btn-primary w-100 mb-3">
                            Add Tax
                        </button>

                        <button type="button" className="btn btn-secondary w-100"
                            onClick={() => {
                                addTaxSet(false);
                                selectedTaxSet(undefined);
                                taxIncludedSet(false);
                            }}>
                            Discard
                        </button>

                    </Form>

                </BottomSheet>
            }

            {
                editInvoice &&
                <DrawerForm id="modal-update-billinginfo"
                    title={`Edit ${invoiceOrEstimate} Details`}
                    buttonText="Update Details"
                    onClose={() => editInvoiceSet(false)}
                    onSubmit={(body, callback) => {



                    }}>
                    <DatePicker id="dt-invoice-date" name="date" block label={`${invoiceOrEstimate} Date`} labelUp date={model?.issuedAt} />


                    <FormTitle title="Pay To" margin={0} className="mb-2" />
                    <TextBox id="txt-isseubyname" name="issuename" block labelUp autoFocus value={model?.issuedByName} placeholder="Company Name" />
                    <PhoneInput id="txt-isseubyphone" name="issuephone" block labelUp defaultValue={model?.issuedByPhone} />
                    <TextArea name="issueaddress" block labelUp placeholder="Company Address" value={model?.issuedByAddress} rows={3} marginBottom={5} />


                </DrawerForm>
            }

            {
                updateIssuedModal &&
                <Modal id="modal-update-issuedinfo"
                    title="Update Company"
                    buttonText="Update Company"
                    open visible staticBackdrop
                    onClose={() => updateIssuedModalSet(false)}
                    onSubmit={(body, callback) => {

                        var valid = true;
                        var focus = true;



                        if (!valid) {
                            callback!();
                            return;
                        }

                        hub.Post(API_ROUTES.JobInvoices + "issueby", {
                            ...body,
                            id: props.invoiceId
                        }, res => {
                            if (res.success) {
                                modelSet(res.data);
                            }
                            callback!(res);
                        });

                    }}>
                    <TextBox id="txt-isseubyname" name="name" block labelUp label="Company Name" autoFocus value={model?.issuedByName} placeholder="Customer/Company Name" />
                    <PhoneInput id="txt-isseubyphone" name="phone" block labelUp label="Company Phone" defaultValue={model?.issuedByPhone} />
                    <TextArea name="address" block labelUp label="Company Address" value={model?.issuedByAddress} rows={5} />
                </Modal>
            }

            {
                sendInvoiceModal &&
                <BottomSheet id="modal-send-invoice"
                    open minHeight={500}
                    onClose={() => {
                        sendInvoiceModalSet(false);
                        sendAllSet(false);
                    }}>

                    <Form id="modal-send-invoice-form" autoIndiactor
                        onSubmit={(body, callback) => {

                            var ids = "";
                            if (sendAll && !model?.issued) {
                                estimates?.forEach(e => {
                                    if (ids != "") ids += ",";
                                    ids += e.id
                                });
                            }
                            else if (sendAll && model?.issued) {
                                invoices?.forEach(e => {
                                    if (ids != "") ids += ",";
                                    ids += e.id
                                });
                            }
                            else ids = props.invoiceId;

                            hub.Post(API_ROUTES.JobInvoices + "sendinvoice", {
                                ...body,
                                ids,
                                sendTo: sendTo,
                                jobId: props.job.id
                            }, res => {
                                if (res.success) {
                                    sendInvoiceModalSet(false)
                                    sendAllSet(false)
                                    fetchInvoice()
                                    toastSuccess(`${sendAll ? invoiceOrEstimates : invoiceOrEstimate} sent successfully!`)
                                }
                                callback!(res)
                            })
                        }}>

                        <div>

                            <FlexRow className="mb-5">
                                <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start me-5 px-6 py-4 ${(sendTo == "email" ? "active" : "")}`}>
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start">
                                        <input className="form-check-input" type="radio" checked={sendTo == "email"}
                                            onChange={e => {
                                                if (e.target.checked) sendToSet("email")
                                            }} />
                                    </span>
                                    <span className="ms-2">
                                        <span className="fs-7 fw-bold text-gray-800 d-block">
                                            Email
                                        </span>
                                    </span>
                                </label>
                                <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start me-5 px-6 py-4 ${(sendTo == "phone" ? "active" : "")}`}>
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start">
                                        <input className="form-check-input" type="radio" checked={sendTo == "phone"}
                                            onChange={e => {
                                                if (e.target.checked) sendToSet("phone")
                                            }} />
                                    </span>
                                    <span className="ms-2">
                                        <span className="fs-7 fw-bold text-gray-800 d-block">
                                            SMS
                                        </span>
                                    </span>
                                </label>
                                <label className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex text-start px-6 py-4 ${(sendTo == "phone" ? "active" : "")}`}>
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start">
                                        <input className="form-check-input" type="radio" checked={sendTo == "wa"}
                                            onChange={e => {
                                                if (e.target.checked) sendToSet("wa")
                                            }} />
                                    </span>
                                    <span className="ms-2">
                                        <span className="fs-7 fw-bold text-gray-800 d-block">
                                            WhatsApp
                                        </span>
                                    </span>
                                </label>
                            </FlexRow>

                            {
                                sendTo == "email" &&
                                <TextBox id="txt-invoice-send-email" key="txt-invoice-send-email" name="emails" email label="Email Address"
                                    labelUp block autoFocus value={props.job.emailAddress ?? model?.billingEmail} />
                            }

                            {
                                sendTo == "phone" &&
                                <PhoneInput id="txt-invoice-send-phone" key="txt-invoice-send-phone"
                                    name="phone" label="Phone Number" parent="modal-send-invoice"
                                    labelUp block autoFocus />
                            }

                            {
                                sendTo == "wa" &&
                                <PhoneInput id="txt-invoice-send-phone-wa" key="txt-invoice-send-phone-wa"
                                    name="phone" label="Phone Number" parent="modal-send-invoice"
                                    labelUp block autoFocus countryCodes="all" />
                            }


                        </div>

                        <button type="submit" className="btn btn-success w-100 mb-3">
                            Send
                        </button>

                        <button type="button" className="btn btn-secondary w-100"
                            onClick={e => {
                                e.preventDefault()
                                sendInvoiceModalSet(false)
                                sendAllSet(false)
                            }}>
                            Discard
                        </button>

                    </Form>

                </BottomSheet>
            }

            {
                confirmModal &&
                <Modal id="modal-confirm-invoice"
                    title={"Approve Estimate " + model?.number}
                    buttonText="Approve"
                    buttonColor="success"
                    open visible
                    onClose={() => {
                        confirmModalSet(false);
                    }}
                    onSubmit={(body, callback) => {

                        hub.Post(API_ROUTES.JobInvoices + "confirmestimate", {
                            ...body,
                            jobId: props.job.id,
                            id: model?.id
                        }, res => {
                            fetchInvoice();
                            callback!(res);
                        })

                    }}>

                    <div>
                        Are you sure you want to mark the selected estimate as Approved?
                    </div>

                </Modal>
            }

            {
                undoConfirmModal &&
                <Modal id="modal-undoconfirm-invoice"
                    title={"Undo Approve Estimate " + model?.number}
                    buttonText="Undo Approve"
                    buttonColor="warning"
                    open visible
                    onClose={() => {
                        undoConfirmModalSet(false);
                    }}
                    onSubmit={(body, callback) => {

                        hub.Post(API_ROUTES.JobInvoices + "undoconfirmestimate", {
                            ...body,
                            jobId: props.job.id,
                            ids: model?.id
                        }, res => {
                            fetchInvoice();
                            callback!(res);
                        })
                    }}>

                    <div>
                        Are you sure you want to unapprove the selected estimates?
                    </div>

                </Modal>
            }

            {
                deleteModal &&
                <Modal id="modal-delete-invoice"
                    title={`Delete ${invoiceOrEstimate}`}
                    buttonText={`Delete ${invoiceOrEstimate}`}
                    buttonColor="danger"
                    open visible
                    onClose={() => {
                        deleteModalSet(false);
                    }}
                    onSubmit={(body, callback) => {

                        hub.Delete(API_ROUTES.JobInvoices + model?.id, res => {
                            callback!(res);
                            if (model?.issued) nav("/crm/jobs/invoices/" + model?.jobId);
                            else nav("/crm/jobs/estimates/" + model?.jobId);
                        })

                    }}>

                    <div>
                        Are you sure you want to delete the {invoiceOrEstimate.toLowerCase()}?
                    </div>

                </Modal>
            }

            {
                estToInvErrModal &&
                <Modal id="modal-estto-invoice-err"
                    title="Create Invoice"
                    open visible
                    onClose={() => {
                        estToInvErrModalSet(false);
                    }}
                    cancelButton cancelText="Ok">

                    <div className="alert alert-warning">
                        You should close the job before creating invoice!
                    </div>

                </Modal>
            }

            {
                estToInvModal &&
                <Modal id="modal-estimate-to-invoice"
                    title={`Create Invoice`}
                    buttonText={`Create Invoice`}
                    buttonColor="success"
                    open visible
                    onClose={() => {
                        estToInvModalSet(false);
                    }}
                    onSubmit={(body, callback) => {

                        hub.Post(API_ROUTES.JobInvoices + "esttoinv", {
                            id: model?.id
                        }, res => {
                            callback!(res);
                            if (res.success) {
                                nav("/crm/jobs/invoices/" + model?.jobId + "/view/" + res.data.id);
                            }
                        })

                    }}>

                    <div>
                        Do you want to create an invoice based on the selected estimate?
                    </div>

                </Modal>
            }

            {
                convertConfirmModal &&
                <Modal id="modal-convert-estimate-to-invoice"
                    title="Convert to Invoice"
                    buttonText="Convert"
                    buttonColor="primary"
                    open visible
                    onClose={() => convertConfirmModalSet(false)}
                    onSubmit={(body, callback) => {
                        hub.Post(API_ROUTES.JobInvoices + "esttoinv", {
                            id: model?.id
                        }, (res: any) => {
                            callback!(res);
                            if (res.success && res.data) {
                                convertConfirmModalSet(false);
                                openInvoicesJobView(res.data, globalState.invoiceJobViewOnClose ?? (() => { }));
                            }
                        })
                    }}>
                    <div>
                        Do you want to convert this estimate into an invoice?
                    </div>
                </Modal>
            }

            {
                previewModal &&
                <Modal id="modal-preview-invoice"
                    open visible size="XLarge"
                    title={`Preview ${invoiceOrEstimate} ${model?.number}`}
                    onClose={() => previewModalSet(false)}
                    buttonText="Download PDF"
                    confirmLink={`${env.hubUrl}/base/public/job/invoice/download/${owner?.id}/${props.invoiceId}/${model?.token}`}>
                    <iframe src={`${env.hubUrl}/base/public/job/invoice/preview/${owner?.id}/${props.invoiceId}/${model?.token}`}
                        style={{
                            width: "100%",
                            height: (globalState.windowsHeight ?? 800) - 200
                        }}>
                    </iframe>
                </Modal>
            }

        </>
    )
}

const statusPill = (bg: string, color: string): React.CSSProperties => ({
    display: "inline-flex",
    alignItems: "center",
    fontSize: 11,
    fontWeight: 500,
    color,
    background: bg,
    padding: "4px 10px",
    borderRadius: 999
})

const totalRow: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8
}

const totalLabel: React.CSSProperties = {
    fontSize: 13,
    fontWeight: 500,
    color: "var(--bs-secondary-color)"
}

const totalValue: React.CSSProperties = {
    fontSize: 14,
    fontWeight: 600,
    color: "var(--bs-body-color)"
}

const SWIPE_ACTION_W = 72
const SWIPE_REVEAL = SWIPE_ACTION_W * 2

type SwipeRowProps = {
    rowKey: number
    openRowKey: number | null
    onOpenChange: (k: number | null) => void
    onEdit: () => void
    onDelete: () => void
    children: React.ReactNode
}

function SwipeRow({ rowKey, openRowKey, onOpenChange, onEdit, onDelete, children }: SwipeRowProps) {
    const [x, setX] = useState<number>(0)
    const [animating, animatingSet] = useState<boolean>(true)
    const startX = useRef<number | null>(null)
    const startY = useRef<number | null>(null)
    const baseX = useRef<number>(0)
    const movedRef = useRef<boolean>(false)
    const lockedAxis = useRef<"x" | "y" | null>(null)

    const isOpen = openRowKey === rowKey

    useEffect(() => {
        animatingSet(true)
        if (!isOpen) setX(0)
        else setX(-SWIPE_REVEAL)
    }, [isOpen])

    const lastTouchAt = useRef<number>(0)

    const onTouchStart: React.TouchEventHandler<HTMLDivElement> = (e) => {
        lastTouchAt.current = Date.now()
        startX.current = e.touches[0].clientX
        startY.current = e.touches[0].clientY
        baseX.current = x
        movedRef.current = false
        lockedAxis.current = null
        animatingSet(false)
    }
    const onTouchMove: React.TouchEventHandler<HTMLDivElement> = (e) => {
        if (startX.current == null || startY.current == null) return
        const dx = e.touches[0].clientX - startX.current
        const dy = e.touches[0].clientY - startY.current
        if (!lockedAxis.current) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return
            lockedAxis.current = Math.abs(dx) > Math.abs(dy) ? "x" : "y"
        }
        if (lockedAxis.current !== "x") return
        movedRef.current = true
        let next = baseX.current + dx
        if (next > 0) next = 0
        if (next < -SWIPE_REVEAL - 24) next = -SWIPE_REVEAL - 24
        setX(next)
    }
    const onTouchEnd: React.TouchEventHandler<HTMLDivElement> = () => {
        lastTouchAt.current = Date.now()
        animatingSet(true)
        if (lockedAxis.current === "x") {
            if (x < -SWIPE_REVEAL / 2) {
                setX(-SWIPE_REVEAL)
                onOpenChange(rowKey)
            } else {
                setX(0)
                if (isOpen) onOpenChange(null)
            }
        }
        startX.current = null
        startY.current = null
    }

    const handleClick = () => {
        if (movedRef.current) {
            movedRef.current = false
            return
        }
        // tap/click فقط swipe رو toggle می‌کنه — برای ویرایش باید دکمه‌ی Edit زده بشه
        if (isOpen) onOpenChange(null)
        else onOpenChange(rowKey)
    }

    const closeAnd = (fn: () => void) => {
        setX(0)
        onOpenChange(null)
        setTimeout(fn, 50)
    }

    return (
        <div
            data-swipe-open={isOpen ? "true" : undefined}
            style={{
            position: "relative",
            overflow: "hidden",
            borderBottom: "1px solid var(--bs-border-color)",
            background: "var(--bs-body-bg)"
        }}>
            <div style={{
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                visibility: x === 0 ? "hidden" : "visible",
                pointerEvents: x === 0 ? "none" : "auto"
            }}>
                <button type="button"
                    onClick={(e) => { e.stopPropagation(); closeAnd(onEdit) }}
                    style={swipeActionBtn("var(--bs-primary)")}>
                    <Icon icon="pen" type="regular" size={16} />
                    <span style={swipeActionLabel}>Edit</span>
                </button>
                <button type="button"
                    onClick={(e) => { e.stopPropagation(); closeAnd(onDelete) }}
                    style={swipeActionBtn("var(--bs-danger)")}>
                    <Icon icon="trash-can" type="regular" size={16} />
                    <span style={swipeActionLabel}>Delete</span>
                </button>
            </div>
            <div
                onClick={handleClick}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                style={{
                    background: "var(--bs-body-bg)",
                    transform: `translateX(${x}px)`,
                    transition: animating ? "transform 220ms cubic-bezier(0.22, 1, 0.36, 1)" : "none",
                    cursor: "pointer",
                    willChange: "transform",
                    position: "relative",
                    zIndex: 1
                }}>
                {children}
            </div>
        </div>
    )
}

const swipeActionBtn = (bg: string): React.CSSProperties => ({
    width: SWIPE_ACTION_W,
    background: bg,
    color: "#fff",
    border: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    cursor: "pointer"
})

const swipeActionLabel: React.CSSProperties = {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 0.2
}
